import { useMemo } from 'react'

import {
  CarePathDefaultTemplate,
  CarePathDefaultTemplateProps,
} from 'components/templates/carePath/landing'
import { SessionType, SpotlightHeroBannerAppSession } from 'interfaces/types'

export const Soya = (props: CarePathDefaultTemplateProps) => {
  const { spotlight } = props
  const listSession = useMemo(() => spotlight?.listSessions || [], [spotlight])
  return (
    <CarePathDefaultTemplate
      {...props}
      spotlight={{
        ...props.spotlight,
        listSessions: [
          {
            ...listSession?.[0],
            navigating: [
              {
                idScroll: 'aivideo',
                sessionLayout: SessionType.SOYA_OPEN_CHAT,
                title: 'Tanya Expert',
                description: '',
                image: '',
                ctaTitle: '',
                type: 'open_chat',
                url: '',
              },
              ...(listSession?.[0] as SpotlightHeroBannerAppSession).navigating,
              {
                idScroll: 'cari',
                sessionLayout: SessionType.SOYA_EXTERNAL_LINK,
                title: 'Cari Tahu Nutrisi Tepat',
                description: '',
                image: '',
                ctaTitle: '',
                type: 'none',
                url: 'https://www.generasimaju.co.id/produk/sgm-eksplor-soya',
              },
            ],
          } as SpotlightHeroBannerAppSession,
          ...listSession.slice(1, listSession.length),
        ],
      }}
    />
  )
}
